export const APPLICATION_JSON = "application/json";

export const APPLICATION_LD_JSON = "application/ld+json";

export const TEXT_YAML = "text/yaml";
